import * as React from 'react';

import { GalleryCell } from '../../components/NewbuildingsComparePage/parts/Cell/cells';
import { IGalleryCell, INewbuildingSummaryCellValue } from '../../types/newbuildingsCompare';
import { Content } from '../../components/FullScreenGallery/Content';
import { FullScreenGallery } from '../../components/FullScreenGallery';
import { GalleryHeaderContainer } from '../GalleryHeader';
import { trackOpenFullGallery } from './tracking';

export interface IGalleryContainerProps {
  cell: IGalleryCell;
  newbuilding?: INewbuildingSummaryCellValue;
}

export function GalleryContainer({ cell, newbuilding }: IGalleryContainerProps): React.JSX.Element {
  const [isOpened, setOpenedState] = React.useState(false);

  const onButtonClick = React.useCallback(() => {
    setOpenedState(true);
    trackOpenFullGallery({ newbuildingId: newbuilding?.id });
  }, []);

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, []);

  return (
    <>
      <GalleryCell cell={cell} onOpen={onButtonClick} />
      {isOpened && (
        <FullScreenGallery
          header={<GalleryHeaderContainer newbuilding={newbuilding} />}
          content={<Content images={cell.data?.images ?? []} />}
          onClose={onClose}
        />
      )}
    </>
  );
}
